import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { RatioOptions } from '@df/ui/atomic/atomic-options';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent } from '@icms/core/content/component/icms-component.decorator';
import { ICmsContent } from '@icms/core/content/component/icms-content.decorator';
import { NICmsContentComponent } from '@icms/core/content/interfaces/icms-content-component.interfaces';
import { NICmsContentField } from '@icms/core/content/interfaces/icms-content-field.interfaces';
import { ButtonStyleComponent } from 'projects/app-default/src/app/common/buttons/button-style/button-style.component';
import { TextBoxComponent } from 'projects/app-default/src/app/common/text-box/text-box.component';
import { NTextBox } from '../../../common/text-box/text-box.component';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';

interface IPageComponentBlogImageAndCopyData extends NICmsContentComponent.IData, NTextBox.IData {
    image: string;
    ratio?: string;
    imageCaption?: string;
}

@ICmsComponent<CmsBlogComponentImageAndCopyComponent>({
    id: 'cms-blog-image-and-copy',
    name: 'Blog / Image and Copy',
    tags: ['Blog'],
    onDemandOnly: true,
    fields: [
        {
            type: NICmsContentField.EFieldType.image,
            key: 'image',
            title: 'Image',
            required: true
        },
        <NICmsContentField.IChoiceField>{
            type: NICmsContentField.EFieldType.choice,
            key: 'ratio',
            title: 'Ratio',
            options: RatioOptions,
            default: 'ratio-4-5'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'imageCaption',
            title: 'Image Caption'
        },
        ...NTextBox.getFields(false, false)
    ]
})
@Component({
    standalone: true,
    imports: [TextBoxComponent, DfModuleImageModule, ICmsClientModule],
    selector: 'cms-blog-component-image-and-copy',
    templateUrl: 'cms-blog-component-image-and-copy.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsBlogComponentImageAndCopyComponent extends UiComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentBlogImageAndCopyData;
}
